import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Label } from "reactstrap";
import { actions as actionsSite } from "../../redux/actions/site";
import BaseService from "../../services/baseService";
import Success from "../../components/messagesModal/success";
import Error from "../../components/messagesModal/error";
import UploadS3 from "../../components/uploadS3/UploadS3";
import { BUCKET_STORAGE } from "../../config/constants";

const imageExtensions = ["png", "jpeg", "jpg"];
const baseService = new BaseService("ondemand-log-query");
const ModalSetResult = ({ row }) => {
  const dispatch = useDispatch();
  const [inputsUpload, setInputsUpload] = useState([{ src: "" }]);
  const [submitting, setSubmitting] = useState(false);
  const validExtensions = ["png", "jpeg", "jpg", "pdf"];

  const renderPreviewUpload = (inputUpload) => {
		if (inputUpload.src) {
			const ext = inputUpload.src.split(".").pop();
			if (imageExtensions.includes(ext)) {
				return  <div className="d-flex mb-2">
                  <img src={inputUpload.src} alt="" style={{ width: "100%" }} />
                </div>
			}

      return  <div className="d-flex mb-2">
                <div style={{border:'1px solid #DEDEDE', flex:1, boxSizing:'border-box', cursor:'pointer'}}
                  onClick={()=>window.open(inputUpload.src,'','')}
                  className="d-flex flex-column justify-content-center align-items-center py-4">
                  <i className="fas fa-file-pdf" style={{fontSize:30, color:'#cc0000'}}/>
                  <strong>Clique para visualizar</strong>
                </div>
              </div>
		}

    return  <div className="d-flex mb-2">
              <div style={{backgroundColor:'#DEDEDE', flex:1}} className="d-flex flex-column justify-content-center align-items-center py-4">
                <i className="fas fa-file-alt" style={{fontSize:30}}/>
                Sem arquivo
              </div>
            </div>
  };

  const setAttachments = ({ url, args: { index } }) => {
    const _inputsUpload = [...inputsUpload];

    _inputsUpload[index].src = url;
    setInputsUpload(_inputsUpload);
  };

  const removeInputUpload = (index) => {
    const _inputsUpload = [...inputsUpload];
    if (_inputsUpload.length > 1) {
      _inputsUpload.splice(index, 1);
      setInputsUpload(_inputsUpload);
    } else {
      setInputsUpload([{ src: "" }]);
    }
  };

  const addNewInputUpload = () => {
    const _inputsUpload = [...inputsUpload];
    _inputsUpload.push({ src: "" });
    setInputsUpload(_inputsUpload);
  };

  const save = async () => {
    setSubmitting(true);

    if (inputsUpload.length === 0) {
      const configModal = {
        component: <Error msg={'Para finalizar a consulta você deve anexar ao menos um PDF ou uma Imagem.'} />,
        title: 'Erro',
      };
      dispatch(actionsSite.closeModal());
      dispatch(actionsSite.setModal(configModal));
      setSubmitting(false);
      return;
    }

    const payload = {
      result: row.result ?? [],
      status: "Finalizado"
    }

    for (const input of inputsUpload) {
      payload.result.push(input.src);
    }

    const res = await baseService.put(row._id, payload);

    const configModal = {
      component: res.error ? <Error msg={res.msg} /> : <Success msg={row.status === "Finalizado" ? 'Complemento adicionado com sucesso, o usuário solicitante será notificado.' :'Consulta finalizada, o usuário solicitante será notificado.'} />,
      title: res.error ? `Erro` : `Sucesso`,
    };
    dispatch(actionsSite.closeModal());
    dispatch(actionsSite.setModal(configModal));

    setSubmitting(false);
  };

  return (
    <Row>
      <Col md="12">
        <Row>
          {inputsUpload.map((inputUpload, index) => (
            <Col sm="4" className="mt-3 mt-sm-0 mb-3" key={index}>
              <Label>Anexo</Label>
              {renderPreviewUpload(inputUpload)}
              <UploadS3 autoUpload={true} extensions={validExtensions} folder="ondemand-queries" bucket={BUCKET_STORAGE} callback={setAttachments} args={{ index }} />
              <div className="d-flex justify-content-between">
                <Button color="danger" className="w-50 mt-2 mr-1" onClick={() => removeInputUpload(index)}>
                  <i className="fas fa-trash"/>
                </Button>
                <Button color="success" className="w-50 mt-2 ml-1" onClick={() => addNewInputUpload()}>
                  <i className="fas fa-plus-circle"/>
                </Button>
              </div>
            </Col>
          ))}
        </Row>
        <div className="d-flex justify-content-end mt-3">
          <Button type="submit" color="primary" disabled={submitting} onClick={() => save()}>
            {submitting ? (
              <>
                <Spinner color="light" size="sm" className="mr-1"/>
                Processando...
              </>
              ) : (
              <>
                <i className="fa-solid fa-floppy-disk mr-1"></i>
                Salvar
              </>
            )}
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default ModalSetResult;
